// components/GoodsForm.tsx
import React from "react";
import { TextField, Button, Box, Typography } from "@mui/material";

type Props = {
  goodsName: string;
  description: string;
  height: number | "";
  imageUrl: string;
  onGoodsNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onHeightChange: (value: number | "") => void;
  onNextStep: () => void;
  hideHeight?: boolean;
};

const GoodsForm: React.FC<Props> = ({
  goodsName,
  description,
  height,
  imageUrl,
  onGoodsNameChange,
  onDescriptionChange,
  onHeightChange,
  onNextStep,
  hideHeight = false,
}) => {
  return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: "column",
      gap: 4,
      alignItems: "center",
      width: "100%"
    }}>
      {/* 上部：画像 */}
      <Box sx={{ 
        width: "100%",
        maxWidth: "500px"
      }}>
        <img
          src={imageUrl}
          alt="商品画像"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "500px",
            objectFit: "contain"
          }}
        />
      </Box>

      {/* 下部：フォーム */}
      <Box 
        component="form" 
        sx={{ 
          display: "flex", 
          flexDirection: "column", 
          gap: 2,
          width: "100%",
          maxWidth: "500px"
        }}
      >
        <TextField
          label="グッズ名"
          value={goodsName}
          onChange={(e) => onGoodsNameChange(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label="グッズの説明"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          fullWidth
          multiline
          rows={4}
          required
        />
        {!hideHeight && (
          <TextField
            label="高さ (m)"
            type="number"
            value={height}
            onChange={(e) => onHeightChange(Number(e.target.value) || "")}
            fullWidth
            required
            inputProps={{
              step: "0.01",
              min: "0"
            }}
          />
        )}
        <Button variant="contained" color="primary" onClick={onNextStep}>
          次へ進む
        </Button>
      </Box>
    </Box>
  );
};

export default GoodsForm;
